
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"500pt","height":"500pt","version":"1.0","viewBox":"0 0 500 500","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M153.2 118.3L105 166.5V293c0 124.5 0 126.6 2 129.8 1.1 1.8 3.4 4.1 5.2 5.2 3.3 2 5.4 2 137.8 2s134.5 0 137.8-2c1.8-1.1 4.1-3.4 5.2-5.2 2-3.3 2-5.4 2-172.8s0-169.5-2-172.8c-1.1-1.8-3.4-4.1-5.2-5.2-3.2-1.9-5.3-2-94.8-2h-91.5l-48.3 48.3zM199 124v40h-80.5l40-40c22-22 40.1-40 40.2-40 .2 0 .3 18 .3 40zm175 18v5H217v-10h157v5zm-144 49v5H126v-10h104v5zm49 0v5l-17.7-.2-17.8-.3-.3-3.3c-.6-6.3-1-6.2 18.3-6.2H279v5zm90 0v5l-40.2-.2-40.3-.3-.3-3.3c-.6-6.6-3.1-6.2 40.8-6.2h40v5zm-175 46v5h-68v-10h68v5zm108 0v5l-47.2-.2-47.3-.3-.3-3.3c-.6-6.6-3.8-6.2 47.8-6.2h47v5zm67 0v5l-28.7-.2-28.8-.3-.3-3.3c-.6-6.5-2-6.2 29.3-6.2H369v5zm-139 46v5H126v-10h104v5zm49 0v5l-17.7-.2-17.8-.3-.3-3.3c-.6-6.3-1-6.2 18.3-6.2H279v5zm90 0v5l-40.2-.2-40.3-.3-.3-3.3c-.6-6.6-3.1-6.2 40.8-6.2h40v5zm-175 46v5h-68v-10h68v5zm108 0v5l-47.2-.2-47.3-.3-.3-3.3c-.6-6.6-3.8-6.2 47.8-6.2h47v5zm67 0v5l-28.7-.2-28.8-.3-.3-3.3c-.6-6.5-2-6.2 29.3-6.2H369v5zm-139 46v5H126v-10h104v5zm49 0v5l-17.7-.2-17.8-.3-.3-3.3c-.6-6.3-1-6.2 18.3-6.2H279v5zm90 0v5l-40.2-.2-40.3-.3-.3-3.3c-.6-6.6-3.1-6.2 40.8-6.2h40v5z"}})])
          )
        }
      }
    